import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { MainService } from '../../../services/main.service';

@Component({
  selector: 'app-skills-detail',
  templateUrl: './skills-detail.component.html',
  styleUrls: ['./skills-detail.component.scss']
})
export class SkillsDetailComponent implements OnInit {

  @ViewChild('m') m: ElementRef;
  @Input() detail;

  constructor(private mainService: MainService) { }

  ngOnInit() {
    this.scrollToDetail();
  }

  public scrollToDetail() {
    if ((window.innerWidth < 992)) {
      window.scrollTo(0, this.getDistanceToDocumentTop(this.m.nativeElement) - 200);
    }
  }

  private getDistanceToDocumentTop(element) {
    let yPosition = 0;
    while (element) {
      yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
      element = element.offsetParent;
    }
    return yPosition;
  }

}
